/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerContact
 */
export interface CustomerContact {
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    identityId: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    externalId: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerContact
     */
    jobTitle?: string | null;
}

/**
 * Check if a given object implements the CustomerContact interface.
 */
export function instanceOfCustomerContact(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "identityId" in value;
    isInstance = isInstance && "externalId" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CustomerContactFromJSON(json: any): CustomerContact {
    return CustomerContactFromJSONTyped(json, false);
}

export function CustomerContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerContact {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'identityId': json['identityId'],
        'externalId': json['externalId'],
        'name': json['name'],
        'jobTitle': !exists(json, 'jobTitle') ? undefined : json['jobTitle'],
    };
}

export function CustomerContactToJSON(value?: CustomerContact | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'identityId': value.identityId,
        'externalId': value.externalId,
        'name': value.name,
        'jobTitle': value.jobTitle,
    };
}

